export { default, QrThemes } from './QRContent'
export type { Props } from './QRContent'
